/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

import { Component } from 'react';

/**

redirected to this page when link is not found

@param

**/

export class NotFound extends Component {
    render () {
        return (
            <h1>NotFound</h1>
        );
    }
}